import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import './style.css'

function getTheme() {
  return document.documentElement.getAttribute("data-theme") === "dark"
    ? "dark"
    : "light";
}

const Logo = () => {
  const [theme, setTheme] = useState(getTheme());

  useEffect(() => {
    const target = document.documentElement;
    const obs = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === "attributes" && m.attributeName === "data-theme") {
          setTheme(getTheme());
        }
      }
    });
    obs.observe(target, { attributes: true, attributeFilter: ["data-theme"] });
    return () => obs.disconnect();
  }, []);

  const src =
    theme === "dark"
      ? "/static/1receipt-white-logo.png"
      : "/static/1receipt-logo.png";

  return (
    <Box>
      <Link to="/">
        <Box className="text-logo" component="img" src={src} alt="1receipt-logo" />
      </Link>
    </Box>
  );
};

export default Logo;
